module.exports = __webpack_public_path__ + "static/img/banner1.da30c57a.png";